/**
 * Listen der Hersteller im Dashboard – rein, ohne Datenbank, damit Dashboard
 * und API dieselben Regeln nutzen.
 */
/** Jeder Hersteller steht in genau einer Liste. */
export const HERSTELLER_ARTEN = ["konfigurator", "stoffverlag", "naehatelier", "sonstige"];
/** Listen mit „Neuer Hersteller“ – Konfigurator-Hersteller und Nähateliers entstehen aus dem Code. */
export const ANLEGBARE_ARTEN = ["stoffverlag", "sonstige"];
export function istAnlegbar(art) {
    return ANLEGBARE_ARTEN.includes(art);
}
/** Die Auswahlkarten unter „Hersteller“, in Anzeigereihenfolge. */
export const HERSTELLER_LISTEN = [
    {
        art: "konfigurator",
        titel: "Hersteller Konfiguratoren",
        beschreibung: "Hersteller mit eigenem Konfigurator – Preise aus Rechenkern oder Hersteller-API.",
    },
    { art: "stoffverlag", titel: "Stoffverlage", beschreibung: "Stofflieferanten für Vorhänge und Raffrollos." },
    { art: "naehatelier", titel: "Nähateliers", beschreibung: "Konfektion nach Atelier-Preisliste (EK netto)." },
    { art: "sonstige", titel: "Sonstige", beschreibung: "Übrige Lieferanten aus dem ERP-Import." },
];
/** Liste aus dem Query-Parameter; null bei fehlendem oder unbekanntem Wert. */
export function listeAus(wert) {
    return HERSTELLER_ARTEN.find((art) => art === wert) ?? null;
}
export function listenTitel(art) {
    return HERSTELLER_LISTEN.find((l) => l.art === art)?.titel ?? art;
}
//# sourceMappingURL=herstellerListen.js.map